import React from 'react'
import PropTypes from 'prop-types'

import { Container, ContentLoader } from './styled'


const Skeleton = props => {
    const { count } = props

    const handleCount = () => {
        let temp = []

        for (let i=0; i<count; i++)
            temp.push(<ContentLoader key={i} {...props}/>)
            
        return temp 
    }

    return (
        <Container>
            {handleCount()}
        </Container>
    )
}

Skeleton.propTypes = {
    count: PropTypes.number,
}

Skeleton.defaultProps = {
    count: 1,
}

export default Skeleton